const PropTypes = require('prop-types');
const React = require('react');
const ReactDOM = require('react-dom');
const classNames = require('classnames');

class ShareInput extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      active: false,
    };
  }

  componentDidUpdate() {
    if (this.state.active) {
      const input = ReactDOM.findDOMNode(this.refs.shareInput);
      input.focus();
      input.setSelectionRange(0, input.value.length);
    }
  }

  toggleShareInput(event) {
    event.preventDefault();
    this.setState({ active: !this.state.active });
  }

  render() {
    return (
      <div className={classNames('shareinput', { 'shareinput--active': this.state.active })}>
        <a href="#" className="shareinput__trigger" onClick={(event) => this.toggleShareInput(event)}>
          <i className="fa fa-share-alt" />
          {I18n.t('js.shared.shareInput.copyURL')}
        </a>
        <div className="shareinput__popover">
          <p> {I18n.t('js.shared.shareInput.shortlinkTip')} </p>
          <input type="text" ref="shareInput" value={this.props.href} onChange={function () {}} />
        </div>
      </div>
    );
  }
}

ShareInput.propTypes = {
  href: PropTypes.string.isRequired,
};

module.exports = ShareInput;



// WEBPACK FOOTER //
// ./javascripts/components/shared/share_input.jsx